export const redirectTo = (urlCallback) => {
  window.location.href = urlCallback();
};

export const redirectToSites = () => {
  redirectTo(() => '/sites');
};

export const redirectToSite = (siteId) => {
  redirectTo(() => `/sites/${siteId}`);
};

export const redirectToNewSite = () => {
  redirectTo(() => '/sites/new');
};

export const redirectToSiteEdit = (siteId) => {
  redirectTo(() => `/sites/${siteId}/edit`);
};

export const redirectToSiteEditElement = (siteId, id, scrollTo) => {
  redirectTo(() => `/sites/${siteId}/edit?id=${id}&scrollTo=${scrollTo}`);
};

export const redirectToTag = (tagId) => {
  redirectTo(() => `/tags/${tagId}`);
};

export const redirectToSiteNote = (siteId, id) => {
  redirectTo(() => `/sites/${siteId}/notes/${id}`);
};

export const redirectToSiteNoteEdit = (siteId, id) => {
  redirectTo(() => `/sites/${siteId}/notes/${id}/edit`);
};

export const redirectToSiteNoteNew = (siteId) => {
  redirectTo(() => `/sites/${siteId}/notes/new`);
};

export const redirectToVisits = () => {
  redirectTo(() => '/visits');
};

export const redirectToSiteVisit = (siteId, id) => {
  redirectTo(() => `/sites/${siteId}/visits/${id}`);
};

export const redirectToSiteVisitEdit = (siteId, id) => {
  redirectTo(() => `/sites/${siteId}/visits/${id}/edit`);
};

export const redirectToSiteVisitNew = (siteId) => {
  redirectTo(() => `/sites/${siteId}/visits/new`);
};

export const redirectToContact = (id) => {
  redirectTo(() => `/contacts/${id}`);
};

export const redirectToContactEdit = (id) => {
  redirectTo(() => `/contacts/${id}/edit`);
};

export const redirectToContacNew = () => {
  redirectTo(() => '/contacts/new');
};

export const redirectToContacts = () => {
  redirectTo(() => '/contacts');
};

export const redirectToSeasons = () => {
  redirectTo(() => '/seasons');
};

export const redirectToSeasonNew = () => {
  redirectTo(() => '/seasons/new');
};

export const redirectToSeasonEdit = (id) => {
  redirectTo(() => `/seasons/${id}/edit`);
};

export const redirectToCustomFieldsEdit = (formId) => {
  redirectTo(() => `/admin/custom_fields/${formId}/edit`);
};

/**
 * Redirect user to the edit (route) page
 * @param routeId id of route to redirect
 */
export const redirectToRouteEdit = (routeId) => {
  redirectTo(() => `/routes/${routeId}/edit?mode=map`);
};

export const redirectToRoutesIndex = () => {
  redirectTo(() => '/routes');
};

export const redirectToMainPage = () => {
  redirectTo(() => '/sites');
};
export const redirectToUrl = (url) => {
  redirectTo(() => url);
};

export const redirectToEditOrganization = (orgId) => {
  redirectTo(() => `/admin/organizations/${orgId}/edit`);
};

export const redirectToOrganization = (orgId) => {
  redirectTo(() => `/admin/organizations/${orgId}`);
};

export const redirectToAccount = () => {
  redirectTo(() => '/admin/account');
};

export const redirectToTags = () => {
  redirectTo(() => '/tags');
};

export const navigateToDashboard = () => {
  redirectTo(() => '/');
};

export const redirectToImport = (id) => {
  redirectTo(() => `/imports/${id}`);
};

export const openNoteModal = (noteId) => {
  redirectTo(() => `/notes?noteId=${noteId}`);
};

/**
 * Redirects to the previous page or a default page if no history is available.
 * @param {Function|null} redirectFunc - If provided, this function will be called if there is no history to go back to.
 * @returns {void}
 */
export const redirectToPreviousPage = (redirectFunc = null) => {
  if (window.history.length > 1) {
    window.history.back();
  } else if (redirectFunc) {
    redirectFunc();
  } else {
    navigateToDashboard();
  }
};
